import AdminDocumentsPageView from './AdminDocumentsPageView';

export default AdminDocumentsPageView;
